import { Instagram, Facebook } from "lucide-react";

export default function Footer() {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  const year = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-black pt-20">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid md:grid-cols-2 gap-10 pb-16 border-b border-surface-border">
          <div>
            <img src="/brand/logo.jpeg" alt="Hot Packz Grabba" className="w-40 mb-6" />
            <p className="text-muted-foreground max-w-sm text-sm leading-relaxed">
              Crushed grabba from a proprietary blend of hand-picked leaf
              strains. Find us at authorized retailers and follow the movement.
            </p>
          </div>
          <div className="flex flex-col md:items-end gap-4">
            <div className="flex gap-6">
              {["Story", "The Grabba", "Find a Store", "Contact"].map((l) => (
                <button
                  key={l}
                  onClick={() => go(`#${l.toLowerCase().replace(/\s|the\s/g, "").replace("thegrabba", "product").replace("findastore", "locator")}`)}
                  className="font-mono text-xs uppercase tracking-[0.15em] text-muted-foreground hover:text-blaze transition-colors duration-200"
                >
                  {l}
                </button>
              ))}
            </div>
            <a
              href="https://www.instagram.com/hot.packz.grabba/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="inline-flex items-center gap-2 text-gold hover:text-blaze transition-colors duration-200 font-mono text-sm mt-4"
            >
              <Instagram size={18} /> @hot.packz.grabba
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61593601870026"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              className="inline-flex items-center gap-2 text-gold hover:text-blaze transition-colors duration-200 font-mono text-sm mt-4 ml-6"
            >
              <Facebook size={18} /> Hot Packz Grabba
            </a>
          </div>
        </div>

        {/* Giant brand watermark */}
        <div className="py-10 overflow-hidden">
          <h2 className="font-display uppercase text-outline text-[19vw] leading-none text-center select-none">
            HOT PACKZ
          </h2>
        </div>
      </div>

      {/* Legal tobacco warning */}
      <div data-testid="warning-bar" className="bg-white text-black">
        <div className="mx-auto max-w-7xl px-6 py-8">
          <p className="font-heading uppercase text-xs tracking-[0.2em] text-center mb-5">
            Surgeon General's Warnings
          </p>
          <ul className="grid sm:grid-cols-2 gap-x-10 gap-y-3 max-w-5xl mx-auto">
            {[
              "SURGEON GENERAL'S WARNING: Smoking Causes Lung Cancer, Heart Disease, Emphysema, And May Complicate Pregnancy.",
              "SURGEON GENERAL'S WARNING: Quitting Smoking Now Greatly Reduces Serious Risks to Your Health.",
              "SURGEON GENERAL'S WARNING: Smoking By Pregnant Women May Result in Fetal Injury, Premature Birth, And Low Birth Weight.",
              "SURGEON GENERAL'S WARNING: Cigarette Smoke Contains Carbon Monoxide.",
            ].map((w, i) => (
              <li key={i} className="flex gap-3 text-[11px] sm:text-xs font-semibold leading-snug uppercase">
                <span className="font-mono text-black/50">0{i + 1}</span>
                <span>{w}</span>
              </li>
            ))}
          </ul>
          <p className="text-center font-heading uppercase text-xs sm:text-sm tracking-wide mt-6 pt-5 border-t border-black/15">
            WARNING: This product contains nicotine. Nicotine is an addictive chemical.
          </p>
        </div>
      </div>

      <div className="bg-black">
        <div className="mx-auto max-w-7xl px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-muted-foreground/70 text-xs">
          <p>© {year} Hot Packz Grabba™. All rights reserved.</p>
          <p className="font-mono uppercase tracking-widest">21+ Only · Not for sale to minors</p>
        </div>
      </div>
    </footer>
  );
}
